module.exports = __webpack_public_path__ + "img/flag-cl.7c745390.svg";